/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:33:22
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-04-30 16:38:16
 */

export default {
  path: 'ws_account',
  component: () => import(/* webpackChunkName: "ws_account" */ '@/pages/ws/AccountList'),
  meta: {title:'子账号管理',cate:'所有商户管理'}
}
